import dayjs from 'dayjs';

import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {datetimeObjToISOString} from '../../datetime';
import {isCourseCorporate} from './isCourseCorporate';
import {isCourseEvergreen} from './isCourseEvergreen';

type TargetCourse = Nullable<CourseApiModel>;

export const COURSE_EXTENDABLE_DAYS_BEFORE_END = 7;

export const isCourseExtendable = (course?: TargetCourse) => {
  if (!course || isCourseEvergreen(course) || !course.end_date) {
    return false;
  }

  return isCourseCorporate(course) ? b2bStrategy(course) : coreStrategy(course);
};

function b2bStrategy(course?: TargetCourse) {
  if (!course?.end_date) {
    return false;
  }

  const today = dayjs();
  const courseEndDate = dayjs(datetimeObjToISOString(course.end_date));
  const xDaysBeforeEnd = courseEndDate.subtract(
    COURSE_EXTENDABLE_DAYS_BEFORE_END,
    'days',
  );

  const isAllowedByDays = today.isAfter(xDaysBeforeEnd);

  // TODO: should we we move subtenant check to the strategy? (subtenant.auto_restart_on)
  return isAllowedByDays;
}

function coreStrategy(course?: TargetCourse) {
  const hasProperStatus = Boolean(
    course!.status === 'planned' || course!.status === 'ongoing',
  );

  return hasProperStatus;
}
